// Node modules
import {delayedCall, dispatcher, ingenuity, killDelayedCall, Linear, SpineBase } from "@quest/base-core";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { BigWinController, SlotEventConstantsBehavior, SoundConstant, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";

// Game modules
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { EventConstantsLeander } from "@quest/oddsworks-platform";

export class BigWinControllerGame extends BigWinController {
  private textAndManSpinePortrait:SpineBase;
  ANIMATION_BGIWIN_CHAT_START = "in_desktop_fg";
  ANIMATION_BGIWIN_CHAT_LOOP = "loop_desktop_fg";
  ANIMATION_BGIWIN_START = "in_desktop_bg";
  ANIMATION_BGIWIN_LOOP = "loop_desktop_bg";

  ANIMATION_BGIWIN_START_POTRAIT = "in_portrait_bg";
  ANIMATION_BGIWIN_LOOP_POTRAIT = "loop_partrait_bg";
  /**
   * added to initialize portrait components
   */
  protected initializePortraitComponent(): void {
    this.bgLoopPortraitSpine = this.view.getSpineById("big_win_portrait");
    this.textAndManSpinePortrait = this.view.getSpineById("text_Man_Spine_Port");
  }
  /**
   * to change presentaoin complete timming 
   */
  protected bigWinPresentationComplete() {
    (ingenuity.soundManager as any).playSound(SoundConstantGame.BIG_WIN_END_SOUND, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
    (ingenuity.soundManager as any).stop(SoundConstantGame.BIG_WIN_LOOP, gameConstants.SOUND_LIST_POSTLOAD);
    (ingenuity.soundManager as any).stop(SoundConstantGame.BIG_WIN_VOICE, gameConstants.SOUND_LIST_POSTLOAD);

    delayedCall(SlotConstantsBehavior.FADE_OUT_BIG_WIN_DELAY, SlotConstantsBehavior.DURATION_1200, () => {
      killDelayedCall(SlotConstantsBehavior.FADE_OUT_BIG_WIN_DELAY);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
      dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_WIN_METER_BEFORE_CLOSE_IN_BIGWIN, { value: this.currentWinAmountTickUp });
      this.hideBigWin();
      dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_FREE_GAME_WIN_METER_AFTER_BIGWIN, this.currentWinAmountTickUp);
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        // To update the bottom bar win in case of basewin updating from tickup
        dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_BOTTOM_BAR_WIN, { value: (ingenuity.parserModel as GameParserModel).getGameWinAmt() });
       dispatcher.fireEvent(EventConstantsLeander.TOTAL_WIN_UPDATED, { winAmount: ingenuity.parserModel.getTotalWin().toFixed(2) });
        
      }
    }, this);
  }

  protected showBigWinMeterWithZoomIn(): void {
    this.bigWinMeterContainer.visible = true;
            this.bigWinMeterContainer.scale.set(0, 0);
            this.bigWinMeter.visible = false;
            this.startBigWinBasedOnState();
            const bigWinMeterZoomInTween = ingenuity.currentGame.add.tween(this.bigWinMeterContainer.scale).to({ x: 1, y: 1 }, SlotConstantsBehavior.DURATION_400, Linear.None, true, 600, 0, false);
            bigWinMeterZoomInTween.onComplete.addOnce(() => {
                bigWinMeterZoomInTween.stop();
                ingenuity.currentGame.tweens.remove(bigWinMeterZoomInTween);
                this.startBigWinTickup();
            }, this);
  }

  

  /**
 * Method startBigWin Overrided to add sound.
 */
  protected startBigWin(): void {
    ingenuity.configData.bigWinRunning = true;
    super.startBigWin();
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREESPIN_COUNTER); // GP4:To Hide free game count during bigwin in Free Game
      if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD)) {
        (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD).volume = 0;
      }
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD)) {
        (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD).volume = 0;
      }
    }
  }
  /**
   * to add game specific sounds
   */
  protected startBigWinTickup(): void {
    this.bigWinMeter.setValue(0);
    this.bigWinMeter.visible = true;
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ENABLE_STAGE_CLICK);
      this.currentWinAmountTickUp = (ingenuity.parserModel as GameParserModel).getGameWinAmt();
      this.bigWinMeter.startTick(this.currentWinAmountTickUp,true,false,SlotConstantsBehavior.WINTICKUP_BG_2,true,this.bigWinPresentationComplete.bind(this));
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ENABLE_STAGE_CLICK_FG);
      this.currentWinAmountTickUp = this.model.getCurrentWinAmt();
      this.bigWinMeter.startTick(
        this.currentWinAmountTickUp,
        true,
        false,
        SlotConstantsBehavior.WINTICKUP_FG_2,
        true,
        this.bigWinPresentationComplete.bind(this)
      );
    }
  }
  /**
   * to play desktop spine sound
   */
  protected playDesktopSpine() {
    (this.bigWinMainContainer as any).mask = this.view.getShapeById("bigWinMask");
    super.playDesktopSpine();
    delayedCall("bigWinBGDelay", 100, ()=>{
      killDelayedCall("bigWinBGDelay");
      dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.FULLSCREEN_BIGWIN_BG);
    }, this);
    (ingenuity.soundManager as any).playSound(SoundConstant.BIG_WIN_START, 0.5, false, gameConstants.SOUND_LIST_POSTLOAD);
    (ingenuity.soundManager as any).playSound(SoundConstantGame.BIG_WIN_VOICE, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
    (ingenuity.soundManager as any).playSound(SoundConstantGame.BIG_WIN_LOOP, 1, true, gameConstants.SOUND_LIST_POSTLOAD);

  }
  // Add to play portrait bg big win
  protected playPortraitSpine() {
    const winTextandManContainer = this.view.getContainerByID("WinTextAndManContainer");
    (winTextandManContainer.mask as any) = this.view.getShapeById("bigWinMask");
    this.bgLoopPortraitSpine.visible = true;
    this.bgLoopPortraitSpine.playAnim(this.ANIMATION_BGIWIN_START_POTRAIT, false);
    this.bgLoopPortraitSpine.onComplete.addOnce(() => {
      this.bgLoopPortraitSpine.playAnim(this.ANIMATION_BGIWIN_LOOP_POTRAIT, true);
    }, this);

    this.textAndManSpinePortrait.visible = true;
    this.textAndManSpinePortrait.playAnim("in_portrait_fg", false);
    this.textAndManSpinePortrait.onComplete.addOnce(() => {
        this.textAndManSpinePortrait.playAnim("loop_partrait_fg", true);
    }, this);
  }
  // Override to unfade 2nd free game bgm
  protected hideBigWinBasedOnState(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD)) {
        (ingenuity.soundManager as any).getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD).volume = 1;
      }
      this.fadeInBaseGameSound();
      this.model.setIsBigWinRunning(false);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_AFTER_BIGWIN);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    } else {
      if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD)) {
        (ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD).volume = 1;
      }
      ingenuity.currentGame.state.getCurrentState().model.setIsBigWinRunning(false);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_FREE_GAME_AFTER_BIGWIN);

      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOTAL_WIN_MSG);
    }
  }
  /**
   * Method fadeInBaseGameSound to fade in base game loop sound and music spin sound
   */
  private fadeInBaseGameSound(): void {
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD)) {
      (ingenuity.soundManager as any).getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD).volume = 1;
    }
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD)) {
      (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD).volume = 1;
    }
  }
  /**
   * handle flow of bigwinhide
   */
  protected hideBigWin() {
    ingenuity.configData.bigWinRunning = false;
    this.bigWinMeter.visible = false;
    dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BG, { name: gameConstants.FULLSCREEN_BIGWIN_BG, duration: 400 });
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    } else if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.FREEGAME_BG_SHOW);
    }
    this.hideBigWinWithFadeOutEffect();
    ingenuity.configData.enableStageClick = false;
    dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_STAGE_CLICK);
    this.hideBigWinBasedOnState();
  }
  /**
   * reset bigwin
   */
  protected resetElements() {
    super.resetElements();
    if (!ingenuity.deviceEnv.isDesktop) {
        this.textAndManSpinePortrait.visible = false;
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_FREESPIN_COUNTER); // GP4:To Hide free game count during bigwin in Free Game
    }
}
}
